import { render, staticRenderFns } from "./ReportChargeRatesGraph.vue?vue&type=template&id=81324e94&scoped=true&"
import script from "./ReportChargeRatesGraph.vue?vue&type=script&lang=js&"
export * from "./ReportChargeRatesGraph.vue?vue&type=script&lang=js&"
import style0 from "./ReportChargeRatesGraph.vue?vue&type=style&index=0&id=81324e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81324e94",
  null
  
)

export default component.exports